import React from 'react';
import { Link as MuiLink } from '@mui/material';
import { Link as ScrollLink } from 'react-scroll';
import PropTypes from 'prop-types';

const CustomLink = ({ name, to }) => {
  return (
    <ScrollLink
      to={to}
      smooth={true}
      duration={500}
      spy={true}
      offset={-70} // Adjust based on your header height
    >
      <MuiLink
        color="primary"
        underline="hover"
        sx={{
          fontWeight: 500,
          
        }}
      >
        {name}
      </MuiLink>
     </ScrollLink>
  );
};

// PropTypes for type-checking
CustomLink.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

export default CustomLink;
